var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-ui-trait"},[_c('div',{staticClass:"icon",class:'icon-' + _vm.icon + ' type-' + _vm.type,attrs:{"title":_vm.trait.name}}),_c('ViewUiTooltip',{attrs:{"description":_vm.trait.description,"icon":_vm.icon,"title":_vm.trait.name,"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }